module.exports = __webpack_public_path__ + "img/dice-six.b6477d44.svg";